export default function home_contact() {
	
  $('.block-contact .block-title__text > a').click(function(e){
		e.preventDefault();
		$(this).parent().addClass('active');
	});

	$('.block-contact .block-title__text .close-menu').click(function(e){
		e.preventDefault();
		$(this).parent().parent().parent().removeClass('active');
	});
	
}